(ns hypnos.dme.tile.field.consult-service-type
  "Field for the consult service type."
  (:require [clojure.string :as str]
            [hypnos.backoffice.core.patient :as core-patient]
            [hypnos.i18n :refer [tr]]
            [re-frame.core :as rf]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   (let [patient (rf/subscribe [:backoffice/patient])]
     [:div.field.is-horizontal
      [:div.field-label.is-normal
       [:label.label (tr :ui.label/service-type)]]
      [:div.field-body
       [:div.field.is-narrow
        [:div.control
         [:div.select.is-fullwidth
          [:select
           {:type      :text
            :disabled  disabled
            :value     (name (get-in @state [:patient :patient/last-consult :consult/service-type :value]))
            :on-change (fn [e]
                         (let [old-value (get-in @state [:patient :patient/last-consult :consult/service-type :value])
                               new-value (when-not (str/blank? (-> e .-target .-value))
                                           (keyword (str "service-type/" (-> e .-target .-value))))
                               changed?  (or (get-in @state [:patient :patient/last-consult :consult/service-type :dirty?])
                                             (not= new-value old-value))]
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/service-type :value]
                                  new-value)
                           (swap! state assoc-in
                                  [:patient :patient/last-consult :consult/service-type :dirty?]
                                  changed?)
                           (when (= :service-type/new-setup new-value)
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/manufacturer]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/make]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/model]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/mask-was-comfortable?]
                                    {:value    true
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/issues]
                                    {:value    #{}
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/eye-dryness?]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false})
                             (swap! state assoc-in
                                    [:patient :patient/last-consult :consult/claustrophobia-level]
                                    {:value    nil
                                     :dirty?   false
                                     :touched? false}))))
            :on-focus  (fn [_]
                         (swap! state assoc-in
                                [:patient :patient/last-consult :consult/service-type :touched?]
                                true))}
           [:option
            {:key      "new-setup"
             :value    "new-setup"
             :disabled (not (core-patient/enable-service-type? :service-type/new-setup @patient))}
            (tr :ui.service-type/new-setup)]
           [:option
            {:key      "exchange"
             :value    "exchange"
             :disabled (not (core-patient/enable-service-type? :service-type/exchange @patient))}
            (tr :ui.service-type/exchange)]
           [:option {:key "refit" :value "refit"} (tr :ui.service-type/refit)]
           [:option {:key "repap" :value "repap"} (tr :ui.service-type/repap)]]]]
        (when-not disabled [:p.help (tr :ui.help/service-type)])]]])))
